import { hydrateRoot } from 'react-dom/client';

import { Application } from 'shared/components/App/App';
import { IApplicationContext } from 'shared/context/applicationContext/types';
import { TBrowserStore } from '../../../shared/types/store';

interface IDependencies {
  store: TBrowserStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies): void {
  const { store, context } = dependencies;
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(rootElement, <Application context={context} store={store} />);
}
